<template>
  <v-app>
    <v-main>
      <General/>
    </v-main>
  </v-app>
</template>

<script>
import General from './components/General';
import { Trans } from "@/plugins/Translation";

export default {
  name: 'App',

  components: {
    General,
  },

  data: () => ({
    //
  }),
  async mounted() {
    try {
      await Trans.changeLocale();
    } catch (error) {
      console.log(error)
    }
  },
};
</script>
